import React, { useEffect } from "react";
import Divser from "./About/Divser";
import Aboutbanner from "./About/Aboutbanner";
import Aboutcon from "./About/Aboutcon";
import Contactform from "./About/Contactform";
import Callin from "./About/Callin";
import Infiry from "./About/Infiry";
import Qns from "./Services/Qns";
import Serviceinfo from "./Services/Serviceinfo";
import ServiceList from "./Services/ServiceList";
import Divider from "./Divider";
import Wecare from "./Home/Wecare";
import { movetop } from "../fun";
import { Helmet } from "react-helmet-async";

function About() {
  type elem = {
    oneBody?: JSX.Element;
    twoBody?: JSX.Element;
    threeBody?: JSX.Element;
  };
  const elemnt: elem = {
    oneBody: <Aboutcon />,
    twoBody: <Infiry />,
    threeBody: <Callin />,
  };
  const elemnt2: elem = {
    oneBody: <Qns />,
    twoBody: <Contactform />,
  };

  useEffect(() => {
    movetop();
  }, []);
  return (
    <>
      <Helmet>
        <title>Top polyclinic in Whitefield</title>
        <meta
          name="description"
          content="We are the Top polyclinic in Whitefield and in Vijayanagar. Looking for this then feel free to contact us today."
        />
        <meta
          name="keywords"
          content="Best Polyclinic in Whitefield, Best Polyclinic in Vijayanagar, healthcare services in Whitefield, healthcare services in Vijayanagar, Multispeciality Clinic in Vijayanagar"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "@id": "https://www.elvhealthcare.com/about#organization",
            name: "ELV Health Care Polyclinics",
            url: "https://www.elvhealthcare.com/about",
            description:
              "ELV Health Care Polyclinics is a leading multi-speciality clinic in Whitefield, Bengaluru offering comprehensive healthcare services including diagnostics, consultations across specialties, preventive care, daycare and pharmacy services with an emphasis on patient-centric care and quality treatment.",
            logo: "https://www.elvhealthcare.com/favicon.ico",
            telephone: ["+91-9535264855", "+91-9535264854"],
            email: "elvhealthcare@gmail.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "MR ASTER, Ground Floor, Vijayanagar, Whitefield",
              addressLocality: "Bengaluru",
              addressRegion: "Karnataka",
              postalCode: "560066",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: 12.9764418,
              longitude: 77.7583566,
            },
            hasMap: "https://maps.app.goo.gl/C1xXW4kQyTxR8Sug9",
            knowsAbout: [
              "Multi-speciality clinic services",
              "Diagnostic imaging and lab testing",
              "Primary care and specialist consultations",
              "Preventive health screening",
              "Daycare and minor procedures",
              "Pharmacy and medication support",
              "Chronic disease management and follow-up care",
            ],
            keywords: [
              "Best Poly clinic in Immadihalli",
              "Best Poly clinic in Whitefield",
              "Best Poly clinic in Bangalore",
              "Best Poly clinic in Kundalahalli",
              "Best Poly clinic in Pattandur Agrahara",
            ],
          })}
        </script>
      </Helmet>
      <h2 style={{ display: "none" }}>
        Top polyclinic in Whitefield embodying the ethos of compassionate and
        comprehensive healthcare. Are you looking for the top polyclinic in
        Whitefield? Then feel free to contact us today.
      </h2>

      <Aboutbanner name="About Us" banner={"../photo/sam2.jpg"} />
      {/* <div style={{ backgroundColor: "#eff6ff" }} className="pb-2">
        <Infobox />
      </div> */}
      <Serviceinfo />
      <ServiceList />
      {/* <Aboutinfo /> */}
      {/* <Doctorbox /> */}
      {/* <div className="py-4">
        <Contactbynum color={"#fafafa"} />
      </div> */}
      {/* <ServiceList /> */}
      {/* <Serviceinfo /> */}
      <div className="pt-0 pb-6"></div>
      <Divser elemnt={elemnt} />
      <div className="pt-10 pb-4">
        <Divider />
      </div>
      <Divser elemnt={elemnt2} />
      <div className="pt-10 pb-3">
        <Divider />
      </div>
      {/* <div className="pt-10">
        <ContactwithWat />
      </div> */}
      {/* <ServiceReview /> */}
      <Wecare />
    </>
  );
}

export default About;
